import { Controller } from "react-hook-form";
import "./element.scss";
import PhoneInput from "../../../phone-input/phone-input";
import { memo } from "react";


interface DynamicPhoneProps {
  formControl: any;
  fieldArrayName: string;
  name: string;
  label?: string;
  placeholder?: string;
  defaultValue?: any;
  required?: boolean;
  disabled?: boolean;
  hidden?: boolean;
  country?: string;
}

const DynamicPhone = memo((props: DynamicPhoneProps) => {
  return (
    <Controller
      control={props.formControl}
      name={`${props.fieldArrayName}.${props.name}`}
      render={({ field,fieldState }) => (
        <PhoneInput
          {...field}
          dataPosition={props.position}
          dataName={`${props.fieldArrayName}.${props.name}`}
          label={props.label}
          required={props.formType === "builder" ? false : props.required}
          placeholder={props.placeholder}
          default_value={props.default_value}
          onChange={(val) => field.onChange(val)}
          error={Boolean(fieldState.error?.message)}
          disabled={props.disabled}
          helperText={fieldState.error?.message || ""}
          setCountryCodeField={props.setCountryCodeField}
        />
      )}
    />
  );
});
export { DynamicPhone };
export default DynamicPhone;
